import styled from 'styled-components';
import {RedLabel,BlueLabel} from '../../atoms/Label';

export default {
	ScoreWrapper : styled.h3`
        margin-top : 0;
    `,
	PartResult : styled.h4`
    `,
	AnswerStyle : styled.span`
		border: 1px dotted gray;
		border-radius: 1em;	
	`,
	AnswerTextStyle : styled.span`
		visibility:hidden;
    `,
	OKLabel : styled(BlueLabel)`
        margin-left : 1rem;
        cursor : ${ ({onClick}) => onClick && 'pointer'};
        text-decoration: ${ ({onClick}) => onClick && 'underline'};
    `,
	NGLabel : styled(RedLabel)`
        margin-left : 1rem;
        cursor : ${ ({onClick}) => onClick && 'pointer'};
        text-decoration: ${ ({onClick}) => onClick && 'underline'};
    `,
	AnswerLabel : styled.label`
        margin-left : 1rem;
    `,
	AnswerDetailPanel : styled.div`
        padding-left : 1rem;
    `,
	Expander : styled.div`
        cursor : pointer;
        text-decoration: underline;
    `,
	Explanation : styled.div`
        margin-top : 1rem;
        white-space : pre-wrap;
    `,
	ScorePointWrapper : styled.span`
        padding-left : 1rem;
    `
};